import { createContext } from 'react'

export type ToastKind = 'success' | 'error' | 'info' | 'warning'

export interface ToastAction {
  label: string
  onClick: () => void
}

export interface ToastInput {
  id?: string
  title?: string
  description?: string
  kind?: ToastKind
  duration?: number
  action?: ToastAction
}

export interface ToastContextValue {
  show: (t: ToastInput) => string
  dismiss: (id: string) => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)
